// Identity of an open scorecard. Aggregate ids are NOT stable: every scoring
// run bulk-inserts fresh Tournaments2::NewAggregate rows and soft-deletes the
// previous ones, so a poll that brings a new score hands every row a new
// id_str. Keying the details slice by the aggregate id would close each open
// scorecard on the next update (the row remounts under a key nothing in the
// slice matches). The players an aggregate stands for do not change across
// rescores, so their member ids identify the row instead; the current
// aggregate id is looked up from the event data only when a URL needs it.
export const detailsKeyFor = (memberIds) => (memberIds ?? []).map(String).join('|');

// Current aggregate id for each open scorecard key, from the event data on
// screen. Keys whose players are no longer in the event resolve to nothing.
export const aggregateIdsByDetailsKey = (eventData, detailsKeys) => {
  const wanted = new Set(detailsKeys ?? []);
  const found = {};

  Object.values(eventData?.scopes ?? {}).forEach((aggregates) => {
    (aggregates ?? []).forEach((agg) => {
      const key = detailsKeyFor(agg.memberIds);
      if (wanted.has(key) && !(key in found)) found[key] = agg.id;
    });
  });

  return found;
};

// Legacy scorecard rule (tournaments2/events/_sum.html.haml): the Total cell
// shows the net's disposition ("NS", "WD", "DQ", ...) instead of the stroke
// sum, which is 0 for a player who never scored. "DNS" is the one disposition
// the legacy card hides here - the row still totals normally.
const HIDDEN_TOTAL_DISPOSITION = 'DNS';

export const scorecardTotalDisplay = ({ disposition, strokeSum }) =>
  disposition && disposition !== HIDDEN_TOTAL_DISPOSITION ? disposition : strokeSum;
